import { useMutation } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { Database } from "@copro/api";

type UpdateCommand = Database["public"]["Tables"]["subject_actions"]["Update"];

async function updateSubjectAction(id: string, command: UpdateCommand) {
  const { data, error } = await apiClient.from("subject_actions")
    .update(command)
    .eq("id", id)
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
}

export function useUpdateSubjectAction() {

  return useMutation({
    mutationFn: async ({ id, command }: { id: string, command: UpdateCommand }) => updateSubjectAction(id, command),
  });
}
